<script setup>
const props = defineProps({
	breadcrumbs: {
		type: Array,
		required: true,
	},
})
</script>

<template>
	<div class="flex items-center gap-5 font-poppins text-sm font-medium uppercase" v-if="breadcrumbs?.length">
		<router-link class="flex items-center gap-3 transition-colors duration-200 hover:text-snk-blue-500" :to="breadcrumbs[0].to" v-if="breadcrumbs[0]">
			<i class="far fa-arrow-left" />
			<div class="mt-1">{{ breadcrumbs[0].label }}</div>
		</router-link>
		<div class="h-5 w-[1.5px] rotate-25 bg-black/15" v-if="breadcrumbs[1]" />
		<div class="flex items-center gap-2 text-snk-blue-500" v-if="breadcrumbs[1]">
			<div class="mt-1">{{ breadcrumbs[1].label }}</div>
		</div>
	</div>
</template>
